import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

import { UserService } from '@app/services/user.service';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { PermissionLevelType } from '@shared/enums/permission-level.enum';
import { checkPermissionLevel } from '@shared/functions/check-permission-level.function';

export const PermissionLevelGuardFactory = (permissionToCheck: PermissionLevelType): CanActivateFn => {
  return AnyPermissionLevelGuardFactory([permissionToCheck]);
};

/**
 * Allows activate if user has any permission
 * @param permissionsToCheck
 * @returns CanActivateFn
 */
export const AnyPermissionLevelGuardFactory = (permissionsToCheck: PermissionLevelType[]): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const userService = inject(UserService);

    return userService.getCashedUserData().pipe(
      map(user => user.permissionLevel),
      filter((permissionLevel: PermissionLevelType[]) => !!permissionLevel?.length),
      map((permissionLevel: PermissionLevelType[]) => {
        if (checkPermissionLevel(permissionLevel, permissionsToCheck, 'any')) {
          return true;
        }
        const noPermissionUrlTree = router.parseUrl(AppRoutes.NO_PERMISSION);
        if (permissionsToCheck.length <= 1) {
          noPermissionUrlTree.queryParams['permission-required'] = permissionsToCheck[0];
        } else {
          noPermissionUrlTree.queryParams['any-permission-required'] = permissionsToCheck.join(',');
        }
        return noPermissionUrlTree;
      })
    );
  };
};
